import { IconPlus16 } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import * as styles from './FoldersListItem.css';

interface IProps {
  onClick(): void;
}

export function FoldersListItemNew({ onClick }: IProps) {
  return (
    <div {...mergeStyles(styles['container'], styles['container-new-item'])} onClick={onClick}>
      <div className={styles['image']}>
        <IconPlus16 color="primary_100" />
      </div>
      <div className={styles['title']}>Новая подборка</div>
    </div>
  );
}
